import React from 'react';

const TextAreaField = ({ field, onInputChange }) => {
    const { label, cssClass, placeholder, isRequired, value } = field;
    return (
        <div className={`form-field ${cssClass}`}>
            <textarea
                name={label.toLowerCase()}
                placeholder={placeholder}
                rows="4"
                required={isRequired}
                aria-label={placeholder}
                value={value ? value : ''}
                onChange={onInputChange}
            />
        </div>
    );
}

export default TextAreaField;